import React from "react";
import "./Cancel_Order_btn.css";
import { Button } from "react-bootstrap";

function Cancel_Order_btn({ btnText, onClick, disabled }) {
  return (
    <section className="Cancel_Order_btn_holder">
      <Button
        className={`Cancel_Order_btn ${
          disabled ? "disabled-btn" : "active-btn"
        }`}
        onClick={onClick}
        disabled={disabled}
      >
        {btnText}
      </Button>
    </section>
  );
}
export default Cancel_Order_btn;
